import { Component, OnInit } from '@angular/core';
import { CustomersService } from '../../_services/customers.service';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  ToasterModule,
  ToasterService,
  ToasterConfig
} from 'angular2-toaster/angular2-toaster';

import { TyreAgreement } from '../../_models/tyreAgreement';
import { Tyre } from '../../_models/tyre';
import { Dealer } from '../../_models/dealer';
import { CustomerTyre } from '../../_models/customerTyre';
import { Customer } from '../../_models/customer';
import { StatisticsService } from '../../_services/statistics.service';
import { AgreementsService } from '../../_services/agreements.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceAddonsService } from '../../_services/serviceaddons.service';
import { DealersService } from '../../_services/dealers.service';
import { ServiceOffersService } from '../../_services/serviceoffers.service';
import { ServiceAddon } from '../../_models/serviceaddon';
import { StatisticEvent } from '../../_models/statisticevent';
import { TyresService } from '../../_services/tyres.service';


@Component({
  selector: 'app-tyreinfo',
  templateUrl: './tyreinfo.component.html',
  styleUrls: ['./tyreinfo.component.css'],
  providers: [CustomersService, StatisticsService, ServiceAddonsService, TyresService, DealersService]
})

export class TyreInfoComponent implements OnInit {

  private errorMessage: string = '';
  public isLoading: boolean = true;
  private toasterService: ToasterService;
  private serviceaddons: ServiceAddon[];
  private statisticsService: StatisticsService;
  private tyresService: TyresService;
  private dealersService: DealersService;
  private serviceaddonslist = [];
  public calculatedPrice: number = 0.00;
  public totalTyrePrice: number = 0.00;
  public hasResponded: boolean = false;
  private customer: any;
  private sub: Subscription;
  private showSearchByReg: boolean = true;
  private dealercalc: boolean = true;
  //private customerid: string = '';
  //private dealer: string = '5ec7b995f99d985b5e8f02ab'
  private dealerId: string;
  public dealer: Dealer;
  private activatedRoute: ActivatedRoute;
  private subscription: Subscription;
  private customersService: CustomersService;
  public season: string = 'summer';
  private id: string;
  private email: string;
  private customerTyre: CustomerTyre;
  private tyres: Tyre[];
  private numberOfTyres: number;
  private orderType: string;
  public missingTyreInfo: string;
  private confirmModalRef: NgbModalRef;
  public qualityIsSelected: boolean = false;
  //private selectedTyres: number[];
  //private selectedTyreQuality: Tyre;

  private tyreAgreement: TyreAgreement;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });

  constructor(toasterService: ToasterService,
    statisticsService: StatisticsService,
    private serviceAddonsService: ServiceAddonsService,
    activatedRoute: ActivatedRoute,
    customersService: CustomersService,
    tyresService: TyresService,
    dealersService: DealersService,
    private modalService: NgbModal,) {
    this.toasterService = toasterService;
    this.statisticsService = statisticsService;
    this.activatedRoute = activatedRoute;
    this.customersService = customersService;
    this.tyresService = tyresService;
    this.dealersService = dealersService;
  }

  ngOnInit() {

    this.isLoading = true;
    this.customerTyre = new CustomerTyre();
    this.tyreAgreement = new TyreAgreement();
    this.tyreAgreement.final_amount = 0;
    this.tyreAgreement.mounting_price = 0;
    this.tyreAgreement.tyre_price = 0;
    this.tyreAgreement.addons = new Array();
    this.tyreAgreement.order_completed = false;
    this.numberOfTyres = 0;

    // // subscribe to router event
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        //this.customerid = param["cust"];
        this.id = param["id"];
        this.email = param["email"];
        this.season = param["season"];
        this.dealerId = param["dealerId"];
        this.orderType = param["orderType"] != null ? param["orderType"] : "customer";
        //this.dealercalc = (param["dealercalc"] == 'true');

        //if (param['regsearch'] && param['regsearch'] == 'false') {
        //  this.showSearchByReg = false;
        //}
      });

    this.loadDataFromSession();

    this.dealersService
      .get(this.dealerId)
      .subscribe(
        /* happy path */ p => this.dealer = p,
        /* error path */ e => this.errorMessage = e,
        /* onComplete */() => {
        });

    this.serviceAddonsService
      .getDealer(this.dealerId, 'tyreHotel')
      // .getDealer(this.customer.dealer[0]._id,'tyreHotel')
      .subscribe(
        /* happy path */ p => this.serviceaddons = p,
        /* error path */ e => this.errorMessage = e,
        /* onComplete */() => {
          //for (var i = 0; i < this.serviceaddons.length; i++) {
          //  this.serviceaddons[i].selected = true;
          //}
          // this.calculatePrice();
        });
    if (this.id != null) {
      this.customersService.getFromMauticContactId(this.dealerId, this.id).subscribe(
        p => {
          this.customer = p;
        },
        e => this.errorMessage = e,
        () => {
          //console.log('customer: ' + JSON.stringify(this.customer));
          this.prepareTyreData();
          this.isLoading = false;
        });
    }
    else {
      this.customersService.getFromMauticSegmentAndEmail(195, this.dealerId, this.email).subscribe(
        p => {
          this.customer = p;
        },
        e => this.errorMessage = e,
        () => {
          //console.log('customer: ' + JSON.stringify(this.customer));
          this.prepareTyreData();
          this.isLoading = false;
        });
    }
  }

  loadDataFromSession() {
    var sessionAgreement = JSON.parse(sessionStorage.getItem("agree"));
    if (sessionAgreement != null) {
      this.tyreAgreement = sessionAgreement;
      this.numberOfTyres = this.getNumberOfTyres();
    }
  }

  isAddonSelected(id) {
    return this.tyreAgreement.addons.some(e => e._id === id);
  }

  updateTyreOfferings() {
    this.tyresService.getDealer(this.dealerId).subscribe(
      p => this.tyres = p,
      e => this.errorMessage = e,
      () => {
        this.tyres = this.tyres.filter(tyre => {
          return tyre.profile.toString() == this.customerTyre.profile &&
            tyre.diameter.toString() == this.customerTyre.diameter &&
            tyre.width.toString() == this.customerTyre.width &&
            tyre.type == this.customerTyre.type
        });
      });

  }

  prepareTyreData() {
    var isSummerTyre = this.season == "sommer";
    
    this.customerTyre.width = isSummerTyre ? this.customer.micar_sommerdaek_bredde : this.customer.micar_vinterdaek_bredde;
    this.customerTyre.threadDimension1 = isSummerTyre ? this.customer.micar_sommerdaek_1_mm : this.customer.micar_vinterdaek_1_mm1;
    this.customerTyre.threadDimension2 = isSummerTyre ? this.customer.micar_sommerdaek_2_mm : this.customer.micar_vinterdaek_2_mm1;
    this.customerTyre.threadDimension3 = isSummerTyre ? this.customer.micar_sommerdaek_3_mm : this.customer.micar_vinterdaek_3_mm1;
    this.customerTyre.threadDimension4 = isSummerTyre ? this.customer.micar_sommerdaek_4_mm : this.customer.micar_vinterdaek_4_mm1;
    this.customerTyre.profile = isSummerTyre ? this.customer.micar_sommerdaek_profil : this.customer.micar_vinterdaek_profil;
    this.customerTyre.diameter = isSummerTyre ? this.customer.micar_sommerdaek_diameter : this.customer.micar_vinterdaek_diameter;
    this.customerTyre.manufacturer = isSummerTyre ? this.customer.micar_sommerdaek_maerke : this.customer.micar_vinterdaek_maerke;
    this.customerTyre.type = this.season;
    this.orderType = this.orderType;

    this.updateTyreOfferings();
  }

  updatePrice() {
    this.calculatePrice();
  }

  getNumberOfTyres() {
    var numberOfTyres = 0;

    if (this.tyreAgreement.change_tyre_1) { numberOfTyres += 1; }
    if (this.tyreAgreement.change_tyre_2) { numberOfTyres += 1; }
    if (this.tyreAgreement.change_tyre_3) { numberOfTyres += 1; }
    if (this.tyreAgreement.change_tyre_4) { numberOfTyres += 1; }

    return numberOfTyres;
  }

  calculatePrice() {
    this.hasResponded = true;
    var selectedAddonPrice = 0;
    var mountingPricePerTyre = this.dealer.tyreMountingPrice != null ? this.dealer.tyreMountingPrice : 100;

    if (this.tyreAgreement.tyre != null) {
      this.tyreAgreement.tyre_price = this.totalTyrePrice = this.numberOfTyres * this.tyreAgreement.tyre.price.valueOf();
    }

    this.tyreAgreement.addons.forEach(s => selectedAddonPrice += s.price);

    this.tyreAgreement.mounting_price = this.numberOfTyres * mountingPricePerTyre;

    this.tyreAgreement.final_amount = this.tyreAgreement.tyre_price + selectedAddonPrice + this.tyreAgreement.mounting_price;

    if (this.numberOfTyres == 0 && !this.qualityIsSelected && !this.tyreAgreement.addons.length) {
      this.hasResponded = false;
    }
  }

  SelectTyreQuality(tyre: Tyre) {
    if (!this.qualityIsSelected) {
      this.qualityIsSelected = true;
    }
    this.tyreAgreement.tyre = tyre;
    this.calculatePrice();
  }

  SelectTyreAddon(addon: ServiceAddon, event) {
    if (event.target.checked) {
      this.tyreAgreement.addons.push(addon);
    }
    else {
      var index = this.tyreAgreement.addons.findIndex(item => item._id === addon._id);//this.tyreAgreement.addons.indexOf(addon, 0);
      if (index > -1) {
        this.tyreAgreement.addons.splice(index, 1);
      }
    }

    this.calculatePrice();
  }
  SelectTyre(event) {
    //alert(event.target.name + " " + event.target.value + " " + event.target.checked);
    var tyreNumber = event.target.value;
    var checked = event.target.checked;

    if (tyreNumber == 1 || tyreNumber == 2) {
      if (checked) {
        this.tyreAgreement.change_tyre_1 = true;
        this.tyreAgreement.change_tyre_2 = true;
      }
      else {
        this.tyreAgreement.change_tyre_1 = false;
        this.tyreAgreement.change_tyre_2 = false;
      }
    }
    else {
      if (checked) {
        this.tyreAgreement.change_tyre_3 = true;
        this.tyreAgreement.change_tyre_4 = true;
      }
      else {
        this.tyreAgreement.change_tyre_3 = false;
        this.tyreAgreement.change_tyre_4 = false;
      }

    }

    this.numberOfTyres = this.getNumberOfTyres();

    this.calculatePrice();
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    // this.sub.unsubscribe();
  }

  prepareToCheckout(template): void {

    this.tyreAgreement.customer = this.customer;
    this.tyreAgreement.dealer_id = this.dealerId;
    if (this.numberOfTyres == 0 &&
      !this.tyreAgreement.tyre &&
      this.tyreAgreement.final_amount != 0) {
      if (this.dealerId = "63591e878c577855251e44b4") {
        this.tyreAgreement.tyre = {
          "_id": "664f1ba7b21a81415fc8364b",
          "dealer_id": this.dealerId,
          "width": 0,
          "profile": 0,
          "diameter": 0,
          "type": "Kun ydelse",
          "manufacturer": "Kun ydelse",
          "quality": "Kun ydelse",
          "price": 0
        }
      }
      if (this.dealerId = "5ec7b995f99d985b5e8f02ab") {
        this.tyreAgreement.tyre = {
          "_id": "664f47f3b21a81415fc83cd9",
          "dealer_id": this.dealerId,
          "width": 0,
          "profile": 0,
          "diameter": 0,
          "type": "Kun ydelse",
          "manufacturer": "Kun ydelse",
          "quality": "Kun ydelse",
          "price": 0
        }
      }
    };
    if (!this.hasResponded) { 
      this.missingTyreInfo = "dæk der skal skiftes og dækkvalitet";
      this.confirmModalRef = this.modalService.open(template)
    }
    if ((this.numberOfTyres == 0 &&
      this.qualityIsSelected) ||
      (this.numberOfTyres != 0 &&
        !this.qualityIsSelected)) {
      if (this.numberOfTyres == 0 &&
        this.qualityIsSelected) {
        this.missingTyreInfo = "dæk der skal skiftes";
      }
      else {
        this.missingTyreInfo = "dækkvalitet";
      }
      this.confirmModalRef = this.modalService.open(template);
    }
    else if(this.hasResponded) {
      this.gotoCheckout()
    }
  }
  gotoCheckout() {
    sessionStorage.setItem('agree', JSON.stringify(this.tyreAgreement));
    sessionStorage.setItem('dealer', JSON.stringify(this.dealer));
    //if (this.id != null) {
    top.window.location.href = '/#/tyre-checkout?id=' + this.customer.mauticId + '&orderType=' + this.orderType;
    //}
    //else {
    //  top.window.location.href = '/#/tyre-checkout?email=' + this.email + '&orderType=' + this.orderType;
    //}
    console.log(this.tyreAgreement.tyre_price);
  }

  getThreadText(threadDepth) {
    if (threadDepth == null || isNaN(threadDepth)) {
      return "Mangler data";
    }

    var text = threadDepth + " mm";
    if (threadDepth <= 3) {
      text += " (bør udskiftes)";
    }

    return text;
  }

  getThreadStyle(threadDepth) {
    if (threadDepth == null || isNaN(threadDepth) || threadDepth <= 3) {
      return "color: red;";
    }
    else {
      return "color: green;";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/tyreinfo/tyreinfo.component.ts